import React from "react";
import { Routes, Route } from "react-router-dom";

//Layouts
import NonAuthLayout from "../Layouts/NonAuthLayout";
import VerticalLayout from "../Layouts/index";

//routes
import {
  onboardingRoutes,
  publicRoutes,
  adminProtectedRoutes,
  userProtectedRoutes,
} from "./allRoutes";
import AuthProtected from "./AuthProtected";
import { useAppSelector } from "Components/Hooks/hooks";

const Index = () => {
  const user = useAppSelector((state) => state?.auth?.user);
  const isAdmin = user?.role === "admin";

  // Select routes based on user role
  const protectedRoutes = isAdmin ? adminProtectedRoutes : userProtectedRoutes;

  return (
    <React.Fragment>
      <Routes>
        <Route>
          {publicRoutes.map((route, idx) => (
            <Route
              path={route.path}
              element={<NonAuthLayout>{route.component}</NonAuthLayout>}
              key={idx}
            />
          ))}
        </Route>

        <Route>
          {onboardingRoutes.map((route, idx) => (
            <Route
              path={route.path}
              element={<AuthProtected>{route.component}</AuthProtected>}
              key={idx}
            />
          ))}
        </Route>

        <Route>
          {protectedRoutes.map((route, idx) => (
            <Route
              path={route.path}
              element={
                <AuthProtected>
                  <VerticalLayout>{route.component}</VerticalLayout>
                </AuthProtected>
              }
              key={idx}
            />
          ))}
        </Route>
      </Routes>
    </React.Fragment>
  );
};

export default Index;
